<template>
  <v-dialog v-model="dialog" persistent width="950">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9> <v-icon>done</v-icon>Finalizar programación</v-flex> 
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout v-if="listado_funcionarios.length == 0 && bandera_activa_finalizacion">
              <v-flex xs12>
                <v-text-field
                 
                  name="input-7-4"
                  label="Hoja de ruta"
                  v-model="form.comprobante"
                   :rules="$validate(['required'])"
                  required
                  outline
                    clearable
                ></v-text-field>
              </v-flex>

            </v-layout>
                     <!-- para adjuntos obligatorios-->
          <v-layout v-if="listado_funcionarios.length == 0  && bandera_activa_finalizacion==true">
              <v-flex xs12 md12 >
                <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                <div
                  :class="this.file == '' ? 'archivo_vacio' : 'archivo_cargado'"
                >
                  <v-icon>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>

                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    accept="application/pdf"
                    :rules="$validate(['required'])"
                    required
                    outline
                    clearable
                  />
                  {{this.file == '' ? 'Adjuntar documento de respaldo':this.file.name}}
                </div>
                <p class="red--text body-1" v-if="errors.file">
                  *Debe seleccionar un archivo
                </p>

                <p class="red--text body-1" v-if="errors.denied">
                  *Formato no admitido por el sistema
                </p>
              </v-flex>
            </v-layout>
            <v-layout v-if="listado_funcionarios.length > 0 && bandera_activa_finalizacion==false">
              <v-flex xs9>
                <h4>
                  <strong
                    >Listado de servidores publicos que no cuentan con sus
                    programaciones aprobadas o tienen alguna observación</strong
                  >
                </h4>
              </v-flex>
              <v-flex xs3>
                <v-menu open-on-hover buttom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">help_outline</v-icon>
                  </template>
                  <v-card>
                    <v-card-text class="ayuda">
                      <v-layout>
                        <v-flex class="text-xs-center caption">
                          <strong>
                            <p><v-icon>help_outline</v-icon></p>
                            <p>Solo puede aprobar las programaciones cuando</p>
                            <p>todos los servidores públicos del listado</p>
                            <p>tengan sus programaciones aprobadas por sus</p>
                            <p>
                              respectivos jefes y no se encuentren rechazados
                              por los mismos
                            </p>
                          </strong>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout v-if="listado_funcionarios.length == 0 && bandera_activa_finalizacion">
              <v-card color="#DFFF89">
                <h4>
                  <strong
                    >Todos los servidores enviaron su programación de vacaciones
                    y se encuentran sin observaciones</strong
                  >
                </h4>
              </v-card>
            </v-layout>
            <v-layout v-if="listado_funcionarios.length > 0 && bandera_activa_finalizacion==false">
              <v-flex xs12>
                <v-data-table
                  :items="listado_funcionarios"
                  class="elevation-1"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.nombre }}</td>
                    <td class="text-xs-center">{{ props.item.unidad }}</td>
                    <td class="text-xs-center">
                      <v-chip
                        dark
                        :color="
                          props.item.id_estado == 22
                            ? '#9637FF'
                            : props.item.id_estado == 51
                            ? '#00DB15'
                            : props.item.id_estado == 73
                            ? '#7ee06a'
                            : props.item.id_estado == 66
                            ? '#73b6c4'
                            : props.item.id_estado == 72
                            ? '#9d20b6'
                            : props.item.id_estado == 70
                            ? '#c267a5'
                            : props.item.id_estado == 47
                            ? '#9aed65'
                            : props.item.id_estado == 68
                            ? '#6f9eb8'
                            : props.item.id_estado == 67
                            ? '#83e0e3'
                            : props.item.id_estado == 66
                            ? '#b0bed6'
                            : props.item.id_estado == 65
                            ? '#c267be'
                            : props.item.id_estado == 54
                            ? '#8f66b8'
                            : props.item.id_estado == 58
                            ? '#88a7f5'
                            : props.item.id_estado == 57
                            ? '#7c73c3'
                            : props.item.id_estado == 56
                            ? '#64a054'
                            : props.item.id_estado == 55
                            ? '#19afb4'
                            : '#FF3400'
                        "
                      >
                        {{ props.item.estado }}
                      </v-chip>
                    </td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click.prevent="close()" :loading="loading"
            ><v-icon>close</v-icon>
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            @click.prevent="finalizarProgramacion()"
            :disabled="!this.bandera_aprobacion || !form.comprobante"
            ><v-icon>done</v-icon>
            Finalizar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      listado_funcionarios: [],
      form: {},
      valid: false,
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      user: this.$storage.get("user"),
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      bandera_activa_finalizacion:false,
      saldo: null,
      periodo: null,
      id: null,
      id_programacion: null,
      errors: {
        file: false,
        denied: false,
      },
      file: "",
      headers: [
        { text: "Nombre", sortable: false, align: "center" },
        { text: "Dependencia", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
      ],
      bandera_aprobacion: true,
    };
  },
  mounted() {
    this.$bus.$on(
      "openDialogFinalizarProgramacionDelMinisterio",
      async (item) => {
        this.form = item;
        if (this.form.comprobante ||  this.form.comprobante!=null ) {
        
          
        }
         this.form.comprobante = null;
        await this.cargarListadoFuncionario();
        this.dialog = true;
      }
    );
  },

  methods: {
    async cargarListadoFuncionario() {
      let res = [];
      let lista_funcionarios = [];
      this.listado_funcionarios = [];
      this.bandera_activa_finalizacion=false
      let user = this.$storage.get("user");
      try {
        console.log(`
							query{
							runQuery(consulta:"SELECT vacaciones.fn_valida_vacaciones_programadas_por_rrhh(${parseInt(
                this.form.gestion
              )})"){
								respuesta
							}
							}
						`)
        res = await this.$service.graphql({
          query: `
							query{
							runQuery(consulta:"SELECT vacaciones.fn_valida_vacaciones_programadas_por_rrhh(${parseInt(
                this.form.gestion
              )})"){
								respuesta
							}
							}
						`,
        });
        res =
          res.runQuery.respuesta[0].fn_valida_vacaciones_programadas_por_rrhh;
        let res2 = res.split("|");
        let res3 = res.split(";");
        res3.splice(res3.length - 1);
        if (res2[0] == "0") {
          for (let i = 0; i < res3.length; i++) {
            const element = res3[i];
            let element3 = {};
            let elemento1 = element.split("|");

            if (elemento1[0] == "0") {
              element3.unidad = elemento1[1];
              element3.nombre = elemento1[2];
              element3.id_estado = elemento1[3];
              element3.estado = elemento1[4];
            } else {
              element3.unidad = elemento1[0];
              element3.nombre = elemento1[1];
              element3.id_estado = elemento1[2];
              element3.estado = elemento1[3];
            }
            lista_funcionarios.push(element3);
          }
         this.bandera_aprobacion = false;
         this.bandera_activa_finalizacion=false
        } else {
          lista_funcionarios = [];
          this.bandera_activa_finalizacion=true
        }

       this.listado_funcionarios = lista_funcionarios;
       
      } catch (error) {
        console.log(error);
      }
    },
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];

        if (this.$refs.file.value === "") {
          this.errors.file = true;
        } else {
          this.errors.file = false;
        }
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }
        this.file = file;
      }
    },
    close() {
      this.listado_funcionarios = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogFinalizarProgramacionesDelMinisterio");
      this.dialog = false;
    },

    async finalizarProgramacion() {
     this.$confirm('¿Está seguro de finalizar la programación de vacaciones?',async ()=>{
      let user = this.$storage.get("user");
      let respuesta;
      let resps = [];
      let correcto = true;
      this.loading = true;

      try {
    //validando el documento:
    if (this.$refs.file.value === "") {
            this.errors.file = true;
           // this.loading_boton = false;
            return this.errors;
          } else {
           // this.loading_boton = false;
            this.errors.file = false;
          }

          if (this.errors.denied) {
           // this.loading_boton = false;
            return this.errors;
          }
          if (this.file != "" ) {
          let formData = new FormData();
          formData.append("file", this.file);
          let res = await this.$http.post(
            process.env.API_URL + "public/upload",
            formData
          );
          this.form.ruta = res.data;
        }

        respuesta = await this.$service.graphql({
          query: `query{
              runQuery(consulta:"select vacaciones.fn_finaliza_vacacion_programada_por_rrhh(${parseInt(this.form.gestion)},${parseInt(user.id)},'${this.form.comprobante}','${this.form.ruta}')"){
                respuesta
              }
            }
          `,
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_finaliza_vacacion_programada_por_rrhh;
        resps = respuesta.split("|");
        correcto = resps[0];
        if (correcto == "1") {
          this.$message.success(
            "Las programaciones del ministerio fuerón finalizadas exitosamente"
          );
        } else {
          this.$message.error(resps[1]);
        }
        document.location.reload()
      } catch (error) {
        console.log(error);
      }
      this.loading = false;
      this.close();
     })
    },
  },
};
</script>

<style>
.ayuda {
  background: #7ae4db8f;
}
.archivo_vacio {
  background-color: #55aafaea;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  margin: 0 auto 0;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 15em;
}
.archivo_cargado {
  background-color: #6ace61;
  color: #fff;
  cursor: pointer;
  font-size: 1em;
  font-weight: bold;
  margin: 0 auto 0;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 15em;
}
.archivo_vacio .input-file {
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}
.archivo_cargado .input-file {
  cursor: pointer;
  font-size: 10000px;
  margin: 0;
  opacity: 0;
  outline: 0 none;
  padding: 0;
  position: absolute;
  right: -1000px;
  top: -1000px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/FinalizarProgramacionesDelMinisterio.vue